class ChartTypeItemVM {
    chartType: KnockoutObservable<ChartType>;
    image: KnockoutObservable<string>;
    title: KnockoutObservable<string>;
    disabled: KnockoutObservable<boolean>;
    tooltip: KnockoutObservable<string>;

    constructor(chartType: ChartType, image: string, title: string, disabled: boolean = false, tooltip = "") {
        this.chartType = ko.observable(chartType);
        this.image = ko.observable(urlConfigs.siteRoot + image);
        this.title = ko.observable(title);
        this.disabled = ko.observable(disabled);
        this.tooltip = ko.observable(tooltip);
    }
}